import React from "react"
import Typography from "aldoo-ra/Typography"
import FileUpload from "aldoo-ra/FileUpload"
import { CloudArrowUpIcon } from "@heroicons/react/24/outline"

const UploadStep = ({
  onFileUpload,
  uploadError,
  isLoading,
  uploadProgress,
  currentActivity,
  manifest,
}) => {
  return (
    <div className="space-y-8">
      {/* Upload Section */}
      <div className="bg-admin_canvas rounded-2xl p-8 border border-admin_bordered">
        <div className="flex flex-col items-center space-y-6">
          <div className="w-16 h-16 rounded-full bg-admin_primary/10 flex items-center justify-center">
            <CloudArrowUpIcon className="w-8 h-8 text-admin_primary" />
          </div>

          <div className="text-center space-y-2">
            <Typography 
              component="h2"
              variant="admin_h4"
            >
              Upload Update Package
            </Typography>

            <Typography variant="admin_body_dim">
              Select a .7z archive containing the site update
            </Typography>
          </div>

          <FileUpload
            variant="admin_vertical"
            formats={["7z"]}
            maxSize={100}
            onFileChange={onFileUpload}
            onError={(errors) => {}}
            error={uploadError.join(", ")}
            multiple={false}
            disabled={isLoading}
            showSelectedFiles={true}
            className="w-full"
          />

          {isLoading && (
            <div className="w-full space-y-3">
              {uploadProgress > 0 && uploadProgress < 100 ? (
                <div className="space-y-2">
                  <div className="w-full bg-admin_neutral_1 rounded-full h-2.5">
                    <div
                      className="bg-admin_primary h-2.5 rounded-full transition-all duration-300"
                      style={{ width: `${uploadProgress}%` }}
                    ></div>
                  </div>

                  <Typography 
                    variant="admin_body_dim" 
                    className="text-center"
                  >
                    {uploadProgress}%
                  </Typography>
                </div>
              ) : (
                <div className="flex items-center gap-2 justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-admin_primary"></div>
                  <Typography variant="admin_body_dim">
                    Processing...
                  </Typography>
                </div>
              )}

              {currentActivity && (
                <Typography 
                  variant="admin_body" 
                  className="text-center"
                >
                  {currentActivity}
                </Typography>
              )}
            </div>
          )}

          {manifest && !isLoading && (
            <div className="w-full p-4 bg-admin_success/10 border border-admin_success/20 rounded-lg">
              <Typography 
                variant="admin_body" 
                className="text-admin_success text-center"
              >
                ✓ Package uploaded successfully: {manifest.filename}
              </Typography>
            </div>
          )}
        </div>
      </div>

      {/* Information Section */}
      <div className="bg-admin_canvas/50 rounded-xl p-6 border border-admin_bordered/50">
        <Typography 
          variant="admin_body_accent" 
          className="mb-3"
        >
          Package Requirements:
        </Typography>

        <ul className="list-disc marker:text-admin_primary space-y-2 pl-5">
          <li>
            <Typography variant="admin_body">
              File must be in .7z format
            </Typography>
          </li>

          <li>
            <Typography variant="admin_body">
              Maximum file size: 100MB
            </Typography>
          </li>

          <li>
            <Typography variant="admin_body">
              Package must contain a valid manifest file
            </Typography>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default UploadStep
